import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS_SVA_IPS_TABLE } from '../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from './utils/validators';
import { AntimalwareSecurityServersSvaIp } from '@nirvana/shared/dtos/types/policies/common';
import { GzAntimalwareSecurityServersSvaIpsItemFormWebComponent } from './GzAntimalwareSecurityServersSvaIpsItemFormWebComponent';
import { AntimalwareSecurityServersSvaIpUiValue } from '../../../../utils/uiSettings/antimalware/antimalware.types';
import {
  PolicyDependenciesContainer,
  UnifiedEndpointsApiClients,
} from '../../../../../../common/policyPanel/uiSettings/dependencies/PolicyDependenciesContainer';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS_SVA_IPS_TABLE)
export class GzAntimalwareSecurityServersSvaIpsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  AntimalwareSecurityServersSvaIp,
  AntimalwareSecurityServersSvaIp
> {
  protected columns = getTableColumns();
  protected clients: UnifiedEndpointsApiClients = PolicyDependenciesContainer.getInstance().resolveDependency(
    'UnifiedEndpoints'
  ) as UnifiedEndpointsApiClients;

  protected renderGridItemForm(): TemplateResult {
    return html`
      <gz-policy-panel-antimalware-security-servers-sva-ips-item
        id="${GRID_ITEM_FORM_ID}"
      ></gz-policy-panel-antimalware-security-servers-sva-ips-item>
    `;
  }

  protected addGridItem(item: AntimalwareSecurityServersSvaIpUiValue) {
    const { priority, protectedEntityId, ...gridItem } = item;
    this.clients.updateSvaMachines([
      {
        _id: gridItem.endpointId,
        customHostname: gridItem.customHostname,
        protectedEntityId: protectedEntityId,
        ip: gridItem.ip,
      },
    ]);
    super.addGridItem(gridItem, priority);
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: AntimalwareSecurityServersSvaIp): ValidationResult {
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected async onGridItemsChange() {
    await this.gridComponent.updateComplete;

    (this.gridItemForm as GzAntimalwareSecurityServersSvaIpsItemFormWebComponent).resetPrioritySettings(
      this.gridComponent.getFormValue().length + 1
    );
  }
}
